import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
import { ChartContainer, ChartLegend, ChartLegendContent, ChartTooltip, ChartTooltipContent } from "@/components/chart";
import type { JiraMetricsStageCompositionPoint } from "@/http/api-types";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { secondsToDays } from "./formatters";

export function StageCompositionChart({ data }: { data: JiraMetricsStageCompositionPoint[] }) {
  const chartData = data.map(point => ({
    period: point.period,
    in_progress_days: secondsToDays(point.avg_in_progress_seconds),
    review_days: secondsToDays(point.avg_review_seconds),
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Stage Composition (In Progress vs Review)</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer
          className="h-72 w-full"
          config={{
            in_progress_days: { label: "In Progress (workdays)", color: "#4f46e5" },
            review_days: { label: "Review (workdays)", color: "#f97316" },
          }}
        >
          <BarChart data={chartData}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="period" />
            <YAxis />
            <ChartTooltip content={<ChartTooltipContent />} />
            <ChartLegend content={<ChartLegendContent />} />
            <Bar dataKey="in_progress_days" fill="var(--color-in_progress_days)" stackId="stage" />
            <Bar dataKey="review_days" fill="var(--color-review_days)" stackId="stage" />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
